import { Box, Button, fabClasses, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "../Assistant/Assistant.css";
import "./Campaign.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Switch from "@mui/material/Switch";
import Collapse from "@mui/material/Collapse";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import Tick from "../../Images/tick.svg";
import Notimage from "../../Images/number-not.png";
import { getContactList } from "../../services/ContactList";
import { createCampaign, getPhoneNumber } from "../../services/Campaign";
import { getVoiceAssitant } from "../../services/Assistant";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import Autocomplete from "@mui/material/Autocomplete";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import Loader from "../Loader";

// time
dayjs.extend(utc);
dayjs.extend(timezone);

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ECE0FF",
    color: "#747474",
    maxWidth: "300px",
    wordBreak: "keep-all !important",
    fontSize: theme.typography.pxToRem(12),
    borderRadius: "15px",
    boxShadow: "0px 0px 11px 0px rgba(128, 139, 157, 0.15)",
  },
}));
const HtmlTooltip1 = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ECE0FF",
    color: "#747474",
    maxWidth: "60%",
    maxHeight: "60%",
    margin: "0 auto",
    fontSize: theme.typography.pxToRem(12),
    // border: '1px solid #dadde9',
    borderRadius: "15px",
    boxShadow: "0px 0px 11px 0px rgba(128, 139, 157, 0.15)",
  },
}));

// Switch
const label = { inputProps: { "aria-label": "Color switch demo" } };

// Voice1
const ITEM_HEIGHTVoice1 = 40;
const ITEM_PADDING_TOPVoice1 = 8;
const MenuPropsVoice1 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice1 * 10 + ITEM_PADDING_TOPVoice1,
    },
  },
};
// const namesVoice1 = [
//     'Oliver Hansen',
//     'Van Henry',
//     'April Tucker',
//     'Ralph Hubbard',
//     'Omar Alexander',
//     'Carlos Abbott',
//     'Miriam Wagner',
//     'Bradley Wilkerson',
//     'Virginia Andrews',
//     'Kelly Snyder',
// ];
const namesVoice1 = [];
function getStylesVoice1(nameVoice1, personNameVoice1, themeVoice1) {
  return {
    fontWeight: personNameVoice1.includes(nameVoice1)
      ? themeVoice1.typography.fontWeightMedium
      : themeVoice1.typography.fontWeightRegular,
  };
}

// Voice2
const ITEM_HEIGHTVoice2 = 40;
const ITEM_PADDING_TOPVoice2 = 8;
const MenuPropsVoice2 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice2 * 10 + ITEM_PADDING_TOPVoice2,
    },
  },
};
const namesVoice2 = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];
function getStylesVoice2(nameVoice2, personNameVoice2, themeVoice2) {
  return {
    fontWeight: personNameVoice2.includes(nameVoice2)
      ? themeVoice2.typography.fontWeightMedium
      : themeVoice2.typography.fontWeightRegular,
  };
}

// Voice3
const ITEM_HEIGHTVoice3 = 40;
const ITEM_PADDING_TOPVoice3 = 8;
const MenuPropsVoice3 = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHTVoice3 * 10 + ITEM_PADDING_TOPVoice3,
    },
  },
};
const namesVoice3 = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];
function getStylesVoice3(nameVoice3, personNameVoice3, themeVoice3) {
  return {
    fontWeight: personNameVoice3.includes(nameVoice3)
      ? themeVoice3.typography.fontWeightMedium
      : themeVoice3.typography.fontWeightRegular,
  };
}

const drawerWidth = 300;
const CreateCampaign = () => {
  const notify = () => toast.success("Setup Completed");
  const remove = () => toast.success("Deleted successfully");

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));
  const [informationArr, setInformationArr] = useState([
    { email: "test@gmail" },
    { email: "test@gmail" },
  ]);
  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);
  const [load, setLoad] = useState(false);
  const [isLoading,setIsLoading]=useState(true);

  const navigate = useNavigate();

  // Voice1
  const themeVoice1 = useTheme();
  const [personNameVoice1, setPersonNameVoice1] = React.useState([]);
  const handleChangeVoice1 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice1(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  // Voice2
  const themeVoice2 = useTheme();
  const [personNameVoice2, setPersonNameVoice2] = React.useState([]);
  const handleChangeVoice2 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice2(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  // Voice2
  const themeVoice3 = useTheme();
  const [personNameVoice3, setPersonNameVoice3] = React.useState([]);
  const handleChangeVoice3 = (event) => {
    const {
      target: { value },
    } = event;
    setPersonNameVoice3(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const [sameMap, setsameMap] = React.useState(false);
  const [expandedMap, setExpandedMap] = React.useState(false);

  const handleExpandClickMap = () => {
    setsameMap(false);
    setExpandedMap(!expandedMap);
  };
  const handleExpandClickSameMap = () => {
    setExpandedMap(false);
    setsameMap(!sameMap);
  };

  const [isQuestionsOpen, setIsQuestionsOpen] = useState(false);
  const [isInformationOpen, setIsInformationOpen] = useState(false);
  const [isWebhookOpen, setIsWebhookOpen] = useState(false);
  const [allContactList, setAllContactList] = useState([]);
  const [allvoiceAssitant, setAllVoiceAssistant] = useState([]);
  const [allPhoneNumber, setAllPhoneNumber] = useState([]);

  const [assistantId, setassistantId] = useState(null);
  const [numberId, setNumberId] = useState(null);
  const [contactListId, setContactListId] = useState(null);

  const [allCampaign, setAllCampaign] = useState({
    name: "",
    assitantId: "",
    numberId: "",
    contactlistId: "",
    type: "onetime",
    excutetime: "instant",
    starttime: dayjs("1970-01-01T13:30:00").format("HH:mm"), // Store as Date object
    endtime: dayjs("1970-01-01T15:30:00").format("HH:mm"),
  });

  const [errors, setErrors] = useState({
    name: "",
    assitantId: "",
    numberId: "",
    contactlistId: "",
    starttime: "",
    endtime: "",
  });

  const [campaignType, setCampaignType] = useState("onetime");

  useEffect(() => {
    getAllContactList();
    getAllVoiceAssistant();
    getAllPhoneNumber();
  }, []);

  const getAllContactList = async () => {
    setIsLoading(true);
    const response = await getContactList();
    if (response?.data?.success === true) {
      setAllContactList(response.data.result?.data);
      setIsLoading(false);
    } else {
      setIsLoading(false);

    }
  };

  const getAllVoiceAssistant = async () => {
    setIsLoading(true);
    const response = await getVoiceAssitant();
    if (response?.data?.success === true) {
      setAllVoiceAssistant(response.data.result);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const getAllPhoneNumber = async () => {
    setIsLoading(true);
    const response = await getPhoneNumber();
    if (response?.data?.success === true) {
      console.log("response",response)
      setAllPhoneNumber(response.data.result?.data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    // setAllCampaign({ ...allCampaign, [name]: value });
    if (expandedMap1 === true) {
      setAllCampaign({
        ...allCampaign,
        [name]: value,
        starttime:"13:30" ,
        endtime: "15:30",
      });
    } else {
      setAllCampaign({
        ...allCampaign,
        [name]: value,
        starttime:"",
        endtime:""
       
      });
    }
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue?.trim();
    const fieldId = e?.target?.id;
    let isValid = true;
    let errorMessage = {};

    // Handle email validation
    if (fieldName === "name") {
      if (value === "" || value === undefined) {
        // errorMessage.name = "campaign name is required";
        // isValid = false;
      } else if (value.length < 5) {
        errorMessage.name = "campaign name must be 5 characters";
        isValid = false;
      }
    }
    // if (fieldId === "voice assistant" && assistantId === null) {
    //   errorMessage.assitantId = "pleast select the voice assistant";
    //   isValid = false;
    // }
    // if (fieldId === "phone number" && numberId === null) {
    //   errorMessage.numberId = "please select the phone number";
    //   isValid = false;
    // }
    // if (fieldId === "contact list" && contactListId === null) {
    //   errorMessage.contactlistId = "please select the contact list";
    //   isValid = false;
    // }

    // Set errors after validation
    setErrors(errorMessage);

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // const startTime = allCampaign?.starttime?.format("HH:mm");
    // const endTime = allCampaign?.endtime?.format("HH:mm");

    // Validate email
console.log("Allcampa",allCampaign.numberId)
    if (!allCampaign.name) {
      formErrors.name = "Campaign Name is required";
      isValid = false;
    }
    if (allCampaign.name?.length < 5) {
      formErrors.name = " Campaign Name must be 5 characters";
      isValid = false;
    }
    if (!allCampaign.assitantId) {
      formErrors.assitantId = "please select the voice assistant";
      isValid = false;
    }
    if (!allCampaign.numberId) {
      formErrors.numberId = "please select the phone number";
      isValid = false;
    }
    if (!allCampaign.contactlistId && campaignType != "recurring") {
      formErrors.contactlistId = "please select the contactlist";
      isValid = false;
    }
    if (allCampaign.excutetime === "schedule" && !allCampaign.starttime) {
      formErrors.starttime = "please select the start time";
      isValid = false;
    }
    if (allCampaign.excutetime === "schedule" && !allCampaign.endtime) {
      formErrors.endtime = "please select the start time";
      isValid = false;
    }
    if (
      allCampaign.excutetime === "schedule" &&
      allCampaign.starttime === allCampaign.endtime
    ) {
      formErrors.starttime = "please do not provide the same time";
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };

  // const [value, setValue] = React.useState(

  // );

  const handleSubmit = async (e) => {
    e.preventDefault();

    // setAllCampaign({ ...allCampaign, starttime: "",endtime:"" });
    // if (
    //   expandedMap1 === true &&
    //   (allCampaign.starttime === "" || allCampaign.endtime === "")
    // ) {
    //   setAllCampaign({ ...allCampaign, starttime: "13:30", endtime: "15:30" });
    // }

    if (validate()) {
      setLoad(true);
      const response = await createCampaign(allCampaign);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/campaign");
        }, 1000);
        setLoad(false);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };
  // time
  const [value, setValue] = React.useState(
    dayjs.tz("2022-04-17T13:30", "America/New_York")
  );
  const [endValue, setEndValue] = React.useState(
    dayjs.tz("2022-04-17T15:30", "America/New_York")
  );
  const [sameMap1, setsameMap1] = React.useState(false);
  const [expandedMap1, setExpandedMap1] = React.useState(false);

  const handleExpandClickMap1 = (values) => {
    setsameMap(false);
    setExpandedMap1(!expandedMap1);
    if (values === true) {
      setAllCampaign({ ...allCampaign, excutetime: "schedule",starttime:"13:30",endtime:"15:30" });
    } else {
      setAllCampaign({ ...allCampaign, excutetime: "instant" ,starttime:"",endtime:""});
    }
  };
  const handleExpandClickSameMap1 = () => {
    setExpandedMap1(false);
    setsameMap1(!sameMap);
  };

  const handleTimeChange = (field, newValue) => {
    // setTime(newValue);
    if (field === "starttime") {
      setValue(newValue);
    } else {
      setEndValue(newValue);
    }

    if (newValue) {
      // Format the time using Dayjs (if using AdapterDayjs)
      const formatted = newValue.format("HH:mm");
      // Update the state with the formatted time
      setAllCampaign((prevState) => ({
        ...prevState,
        [field]: formatted,
      }));
    }
  };

  if(isLoading) return <Loader/>

  return (
    <div className="Create-Campaign">
      <ToastContainer autoClose={2000} />{" "}
      {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
        <SideBar /> */}
        {/* {isLoading===true && <Loader/>} */}

        {/* <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isLgUp ? 5 : 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            marginTop: isLgUp ? "0px" : "80px",
          }}
        > */}
          <Grid2 container spacing={2}>
            <Grid2
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              className="mb-20"
            >
              <h3>Create Campaign</h3>
              <Box
                sx={{
                  padding: "16px 23px",
                  background: "#fff",
                  borderRadius: "12px",
                  border: "2px solid #8087D7",
                }}
              >
                <div className="Create-Campaign-main">
                  <h3>Campaign Details</h3>
                  <Grid2 item size={{ xs: 12, sm: 12, lg: 6 }}></Grid2>
                  <Grid2 container spacing={2} className="mb-20">
                    <Grid2 item size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}>
                      <div className="display-1">
                        <label>Campaign Type*</label>
                        <HtmlTooltip1
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                <b>
                                  Campaigns are of two types: Recurring and One
                                  Time.
                                </b>
                              </Typography>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                <b>One Time Campaigns:</b>
                                <br />A campaign that runs once, calling a
                                predefined list of contacts, and ends after all
                                calls are made.
                              </Typography>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                <b>Recurring Campaigns:</b>
                                <br />A campaign that continues to run
                                indefinitely, allowing contacts to be added via
                                an API.
                              </Typography>
                              <ul>
                                <li>
                                  {" "}
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                      color: "#747474",
                                    }}
                                  >
                                    <b>Recurring Campaigns:.</b>
                                  </Typography>
                                  <ul>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        Adding a contact list isoptional.
                                      </Typography>
                                    </li>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        Once started, you can{" "}
                                        <b>add contacts</b> to the campaign via
                                        an AΡΙ.
                                      </Typography>
                                    </li>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        If you select a contact list, then these
                                        contacts will be called first before
                                        calling the ones added through API. •
                                        Recurring Campaigns
                                      </Typography>
                                    </li>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        <b>Recurring Campaigns</b> will always
                                        be in running state even if no calls are
                                        pending. will always be in running state
                                        even if no calls are pending.
                                      </Typography>
                                    </li>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        <b>Pause/Resume</b> will work as usual.
                                      </Typography>
                                    </li>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        You would need to <b>Force Stop</b> the{" "}
                                        <b>recurring campaign</b> to End it.
                                      </Typography>
                                    </li>
                                  </ul>
                                </li>
                                <li>
                                  {" "}
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                      color: "#747474",
                                    }}
                                  >
                                    <b>One Time Campaigns:</b>
                                  </Typography>
                                  <ul>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        Adding a contact list isoptional.
                                      </Typography>
                                    </li>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        Campaign is ended after all the contacts
                                        have been called.
                                      </Typography>
                                    </li>
                                    <li>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                          color: "#747474",
                                        }}
                                      >
                                        You can't add contacts to the campaign
                                        after it has started.
                                      </Typography>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip1>
                      </div>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}>
                      <div
                        className="input-common"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <FormControl fullWidth style={{ marginBottom: 10 }}>
                          <Select
                            id="campaign type"
                            displayEmpty
                            value={campaignType}
                            // onChange={handleChangeVoice1}
                            // onFocus={(e) => validateFocus(e)}
                            // onInput={validateFocus}
                            // error={!!errors.assitantId}
                            // helperText={errors.assitantId}
                            input={<OutlinedInput />}
                            MenuProps={MenuPropsVoice1}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            <MenuItem
                              value="recurring"
                              onClick={(e) => {
                                setCampaignType("recurring");
                                setAllCampaign({
                                  ...allCampaign,
                                  type: "recurring",
                                });
                              }}
                            >
                              Recurring
                            </MenuItem>
                            <MenuItem
                              value="onetime"
                              onClick={(e) => {
                                setCampaignType("onetime");
                                setAllCampaign({
                                  ...allCampaign,
                                  type: "onetime",
                                });
                              }}
                            >
                              One Time
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <div className="input-common">
                        <div className="display-1">
                          <label>Campaign Name*</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Enter a descriptive name for your campaign for
                                  your reference.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <TextField
                          fullWidth
                          id="fullWidth"
                          rows={4}
                          placeholder="Enter campaign name"
                          name="name"
                          value={allCampaign.name}
                          onFocus={(e) => validateFocus(e)}
                          onInput={validateFocus}
                          error={!!errors.name}
                          helperText={errors.name}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <div className="input-common">
                        <div className="display-1">
                          <label>Voice Assistant*</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Choose the Al assistant that should be used
                                  during calls.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <FormControl fullWidth>
                          <Select
                            id="voice assistant"
                            displayEmpty
                            value={personNameVoice1}
                            onChange={handleChangeVoice1}
                            onFocus={(e) => validateFocus(e)}
                            onInput={validateFocus}
                            error={!!errors.assitantId}
                            helperText={errors.assitantId}
                            input={<OutlinedInput />}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return <em>Select voice assistant</em>;
                              }
                              return selected.join(", ");
                            }}
                            MenuProps={MenuPropsVoice1}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            {allvoiceAssitant.length === 0 ? (
                              <MenuItem value="">
                                <div
                                  className="cart-not"
                                  onMouseDown={(e) => e.stopPropagation()} // Prevents clicks inside this div from closing the dropdown
                                >
                                  <img
                                    src={Notimage}
                                    alt="Not found"
                                    style={{ width: 180 }}
                                  />
                                  <Typography
                                    variant="h4"
                                    component="h4"
                                    sx={{
                                      paddingTop: "5px",
                                      color: "#989898",
                                      fontSize: "24px",
                                    }}
                                  >
                                    Voice Assistant not found
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    component="p"
                                    sx={{
                                      color: "#989898",
                                      fontSize: "14px",
                                      padding: "15px 0px",
                                    }}
                                  >
                                    Please go to the voice assistant page and
                                    create a voice assistant.
                                  </Typography>
                                  <div className="bg-clr assitant-bg mt-10 mb-10">
                                    <Button
                                      onMouseDown={(e) => e.stopPropagation()} // Prevents button clicks from closing the dropdown
                                      onClick={() => {
                                        navigate("/");
                                        // Add your navigation or action logic here
                                      }}
                                    >
                                      Create a Voice Assistant
                                    </Button>
                                  </div>
                                </div>
                              </MenuItem>
                            ) : (
                              allvoiceAssitant?.map((nameVoice1, index) => (
                                <MenuItem
                                  key={index}
                                  value={nameVoice1?.name}
                                  style={getStylesVoice1(
                                    nameVoice1,
                                    personNameVoice1,
                                    themeVoice1
                                  )}
                                  onClick={() => {
                                    setassistantId(nameVoice1?.id);
                                    setAllCampaign({
                                      ...allCampaign,
                                      assitantId: nameVoice1?.id,
                                    });
                                  }}
                                >
                                  {nameVoice1?.name}
                                </MenuItem>
                              ))
                            )}
                          </Select>
                          <span
                            style={{
                              color: "#d32f2f",
                              fontSize: 13,
                            }}
                          >
                            {errors.assitantId}
                          </span>{" "}
                        </FormControl>
                      </div>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <div className="input-common">
                        <div className="display-1">
                          <label>Phone Number*</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  The dialer outbound phone number that will be
                                  used to place calls to contacts.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <FormControl fullWidth>
                          <Select
                            id="phone number"
                            displayEmpty
                            value={personNameVoice2}
                            onChange={handleChangeVoice2}
                            onFocus={(e) => validateFocus(e)}
                            onInput={validateFocus}
                            error={!!errors.numberId}
                            helperText={errors.numberId}
                            input={<OutlinedInput />}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return <em>Select Phone Number</em>;
                              }

                              return selected.join(", ");
                            }}
                            MenuProps={MenuPropsVoice2}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            {allPhoneNumber.length === 0 ? (
                              <MenuItem value="">
                                <div
                                  className="cart-not"
                                  onMouseDown={(e) => e.stopPropagation()} // Prevents clicks inside this div from closing the dropdown
                                >
                                  <img src={Notimage} alt="Not found" />
                                  <Typography
                                    variant="h4"
                                    component="h4"
                                    sx={{
                                      paddingTop: "5px",
                                      color: "#989898",
                                      fontSize: "24px",
                                    }}
                                  >
                                    Phone Number not found
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    component="p"
                                    sx={{
                                      color: "#989898",
                                      fontSize: "14px",
                                      padding: "15px 0px",
                                    }}
                                  >
                                    Please go to the Phone Number page and
                                    create a Phone Number.
                                  </Typography>
                                  <div className="bg-clr assitant-bg mt-10 mb-10">
                                    <Button
                                      onMouseDown={(e) => e.stopPropagation()} // Prevents button clicks from closing the dropdown
                                      onClick={() => {
                                        navigate("/phone-number");
                                        // Add your navigation or action logic here
                                      }}
                                    >
                                      Create a Phone Number
                                    </Button>
                                  </div>
                                </div>
                              </MenuItem>
                            ) : (
                              allPhoneNumber?.map((nameVoice1, index) => (
                                <MenuItem
                                  key={index}
                                  value={nameVoice1?.name}
                                  style={getStylesVoice1(
                                    nameVoice1,
                                    personNameVoice1,
                                    themeVoice1
                                  )}
                                  onClick={() => {
                                    setNumberId(nameVoice1?.numberId);
                                    setAllCampaign({
                                      ...allCampaign,
                                      numberId: nameVoice1?.numberId,
                                    });
                                  }}
                                >
                                  {nameVoice1?.name}{" "}
                                  <span
                                    style={{ color: "gray", marginLeft: 20 }}
                                  >
                                    ({nameVoice1?.phoneNumber})
                                  </span>
                                </MenuItem>
                              ))
                            )}
                          </Select>
                          <span
                            style={{
                              color: "#d32f2f",
                              fontSize: 13,
                            }}
                          >
                            {errors.numberId}
                          </span>{" "}
                        </FormControl>
                      </div>
                    </Grid2>

                    <Grid2 item size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <div className="input-common">
                        <div className="display-1">
                          <label>Contact List*</label>
                          <HtmlTooltip
                            placement="right"
                            title={
                              <React.Fragment>
                                <Typography
                                  color="inherit"
                                  sx={{ fontSize: "12px", padding: "7px" }}
                                >
                                  Choose the contact list on which you want to
                                  run this campaign. This is optional incase of
                                  recurring campaigns.
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoRoundedIcon />
                          </HtmlTooltip>
                        </div>
                        <FormControl fullWidth>
                          <Select
                            id="contact list"
                            displayEmpty
                            value={personNameVoice3}
                            onChange={handleChangeVoice3}
                            onFocus={(e) => validateFocus(e)}
                            onInput={validateFocus}
                            error={!!errors.contactlistId}
                            helperText={errors.contactlistId}
                            input={<OutlinedInput />}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return <em>Select contact list</em>;
                              }

                              return selected.join(", ");
                            }}
                            MenuProps={MenuPropsVoice3}
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            {allContactList.length === 0 ? (
                              <MenuItem value="">
                                <div
                                  className="cart-not"
                                  onMouseDown={(e) => e.stopPropagation()} // Prevents clicks inside this div from closing the dropdown
                                >
                                  <img src={Notimage} alt="Not found" />
                                  <Typography
                                    variant="h4"
                                    component="h4"
                                    sx={{
                                      paddingTop: "5px",
                                      color: "#989898",
                                      fontSize: "24px",
                                    }}
                                  >
                                    Contact List not found
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    component="p"
                                    sx={{
                                      color: "#989898",
                                      fontSize: "14px",
                                      padding: "15px 0px",
                                    }}
                                  >
                                    Please go to the Contact Lis page and create
                                    a Contact List.
                                  </Typography>
                                  <div className="bg-clr assitant-bg mt-10 mb-10">
                                    <Button
                                      onMouseDown={(e) => e.stopPropagation()} // Prevents button clicks from closing the dropdown
                                      onClick={() => {
                                        navigate("/contact-list");
                                        // Add your navigation or action logic here
                                      }}
                                    >
                                      Create a Contact List
                                    </Button>
                                  </div>
                                </div>
                              </MenuItem>
                            ) : (
                              allContactList?.map((nameVoice1, index) => (
                                <MenuItem
                                  key={index}
                                  value={nameVoice1?.name}
                                  style={getStylesVoice1(
                                    nameVoice1,
                                    personNameVoice1,
                                    themeVoice1
                                  )}
                                  onClick={() => {
                                    setContactListId(nameVoice1?.listId);
                                    setAllCampaign({
                                      ...allCampaign,
                                      contactlistId: nameVoice1?.listId,
                                    });
                                  }}
                                >
                                  {nameVoice1?.name}
                                </MenuItem>
                              ))
                            )}
                          </Select>
                          <span
                            style={{
                              color: "#d32f2f",
                              fontSize: 13,
                            }}
                          >
                            {errors.contactlistId}
                          </span>{" "}
                        </FormControl>
                      </div>
                    </Grid2>
                  </Grid2>
                </div>
              </Box>

              <Box
                sx={{
                  padding: "16px 23px",
                  background: "#fff",
                  borderRadius: "12px",
                  border: "2px solid #8087D7",
                  marginTop: "30px",
                }}
              >
                <div className="display-2 ">
                  <div className="display-1">
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      Post Call Analysis
                    </Typography>
                    <HtmlTooltip
                      placement="right"
                      title={
                        <React.Fragment>
                          <Typography
                            color="inherit"
                            sx={{ fontSize: "12px", padding: "7px" }}
                          >
                            Gather additional insights during your campaign
                            calls & take actions on them. (Optional)
                          </Typography>
                        </React.Fragment>
                      }
                    >
                      <InfoRoundedIcon />
                    </HtmlTooltip>
                  </div>
                  <div className="">
                    <Switch
                      {...label}
                      color="secondary"
                      onClick={handleExpandClickMap}
                    />
                  </div>
                </div>
              </Box>

              <Collapse in={expandedMap} timeout="auto" unmountOnExit>
                <Box
                  sx={{
                    padding: "20px 40px 80px 40px",
                    background: "rgba(47, 2, 78, 0.10)rgba(47, 2, 78, 0.10)",
                    borderRadius: "12px",
                    border: "2px solid #8087D7",
                    marginTop: "10px",
                  }}
                  className="box-pading"
                >
                  <Grid2 container spacing={2}>
                    <Grid2
                      item
                      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    >
                      <div className="display-1">
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                        >
                          Questions :
                        </Typography>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                List of insightful questions that can help
                                catagorise your contacts. This can include
                                simple true/false or multi select questions.{" "}
                                <b>(Max 5)</b>
                              </Typography>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                <b>Example:</b> Was the lead interested in the
                                product?
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                    </Grid2>
                    {isQuestionsOpen ? (
                      <Grid2
                        item
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        className="Add-Question-box"
                      >
                        <Grid2
                          container
                          spacing={4}
                          sx={{ padding: "10px 30px 30px 30px" }}
                        >
                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                          >
                            <div className="input-common mt-20">
                              <div className="display-1">
                                <label>Question</label>
                                <HtmlTooltip
                                  placement="right"
                                  title={
                                    <React.Fragment>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                        }}
                                      >
                                        Information would you like to know from
                                        the conversation.
                                      </Typography>
                                    </React.Fragment>
                                  }
                                >
                                  <InfoRoundedIcon />
                                </HtmlTooltip>
                              </div>
                              <TextField
                                multiline
                                rows={5}
                                fullWidth
                                id="fullWidth"
                                placeholder="Enter first_name value"
                              />
                            </div>
                          </Grid2>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                          >
                            <div className="input-common mt-20">
                              <div className="display-1">
                                <label>Possible answers</label>
                                <HtmlTooltip
                                  placement="right"
                                  title={
                                    <React.Fragment>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                        }}
                                      >
                                        List of possible values of answers to
                                        your question above. (Max 4)
                                      </Typography>
                                    </React.Fragment>
                                  }
                                >
                                  <InfoRoundedIcon />
                                </HtmlTooltip>
                              </div>
                              <TextField
                                fullWidth
                                id="fullWidth"
                                placeholder="Enter first_name value"
                                slotProps={{
                                  input: {
                                    endAdornment: (
                                      <InputAdornment
                                        position="end"
                                        sx={{ gap: "20px" }}
                                      >
                                        {" "}
                                        <IconButton edge="end">
                                          <EditIcon />
                                        </IconButton>
                                        <IconButton edge="end">
                                          <DeleteOutlineOutlinedIcon />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  },
                                }}
                              />
                            </div>
                            <div className="input-common mt-10">
                              <TextField
                                fullWidth
                                id="fullWidth"
                                placeholder="Enter first_name value"
                                slotProps={{
                                  input: {
                                    endAdornment: (
                                      <InputAdornment
                                        position="end"
                                        sx={{ gap: "20px" }}
                                      >
                                        {" "}
                                        <IconButton edge="end">
                                          <EditIcon />
                                        </IconButton>
                                        <IconButton edge="end">
                                          <DeleteOutlineOutlinedIcon />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  },
                                }}
                              />
                            </div>
                            <div className="mt-20 Add-more-button">
                              <Button startIcon={<AddIcon />}>Add More</Button>
                            </div>
                          </Grid2>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                          >
                            <div className="input-common mt-20">
                              <div className="display-1">
                                <label>Shorthand</label>
                                <HtmlTooltip
                                  placement="right"
                                  title={
                                    <React.Fragment>
                                      <Typography
                                        color="inherit"
                                        sx={{
                                          fontSize: "12px",
                                          padding: "7px",
                                        }}
                                      >
                                        A one word identifier for your question.
                                        This would be used as a column header in
                                        campaign analytics pages
                                      </Typography>
                                    </React.Fragment>
                                  }
                                >
                                  <InfoRoundedIcon />
                                </HtmlTooltip>
                              </div>
                              <TextField
                                multiline
                                rows={5}
                                fullWidth
                                id="fullWidth"
                                placeholder="Enter first_name value"
                              />
                            </div>
                          </Grid2>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}
                            sx={{ textAlign: "center" }}
                          >
                            <div className="shadow-btn Question-button mt-30">
                              <Button sx={{ width: "100px" }}>Add</Button>
                            </div>
                            <div className="border-graient Question-button mt-10">
                              <Button onClick={() => setIsQuestionsOpen(false)}>
                                Close
                              </Button>
                            </div>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    ) : (
                      <Grid2
                        item
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        className="Add-Question-box"
                      >
                        <div className="">
                          <Button
                            startIcon={<AddIcon />}
                            onClick={() => setIsQuestionsOpen(true)}
                          >
                            Add Question
                          </Button>
                        </div>
                      </Grid2>
                    )}

                    <Grid2
                      item
                      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    >
                      <div className="display-1">
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                        >
                          Information to be collected
                        </Typography>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                List of information you'd like to collect during
                                call. <b>(Max 8)</b>
                              </Typography>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                <b>Example:</b> email, name, address etc.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <Stack direction="row" spacing={5}>
                        {informationArr?.map((item) => (
                          <div className="Information-button">
                            <p>{item.email}</p>
                            <div className="">
                              <EditIcon /> <DeleteIcon />{" "}
                            </div>
                          </div>
                        ))}
                      </Stack>
                    </Grid2>

                    {isInformationOpen ? (
                      <Grid2
                        item
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        className="Add-Question-box"
                      >
                        <Grid2
                          container
                          spacing={4}
                          sx={{ padding: "10px 30px 30px 30px" }}
                        >
                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
                          >
                            <Grid2 container spacing={2}>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
                              >
                                <div className="characters-heading">
                                  <img src={Tick} />
                                  <p>
                                    {" "}
                                    :Only alphabetic characters and spaces are
                                    allowed.
                                  </p>
                                </div>
                                <div className="characters-heading">
                                  <img src={Tick} />
                                  <p> :No special characters are allowed.</p>
                                </div>
                                <div className="characters-heading">
                                  <img src={Tick} />
                                  <p> :Numerical values are not allowed.</p>
                                </div>
                                <div className="characters-heading">
                                  <img src={Tick} />
                                  <p> :Allowed limit is 100 characters.</p>
                                </div>
                              </Grid2>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                                sx={{ textAlign: "center" }}
                              >
                                <h5>Examples</h5>
                                <p>“ Meeting Date “</p>
                                <p>“ Phone Number “</p>
                              </Grid2>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                              >
                                <div className="display-1">
                                  <h3>Information Gathered</h3>
                                  <HtmlTooltip
                                    placement="right"
                                    title={
                                      <React.Fragment>
                                        <Typography
                                          color="inherit"
                                          sx={{
                                            fontSize: "12px",
                                            padding: "7px",
                                          }}
                                        >
                                          This information is gathered during
                                          the call.
                                        </Typography>
                                      </React.Fragment>
                                    }
                                  >
                                    <InfoRoundedIcon />
                                  </HtmlTooltip>
                                </div>
                              </Grid2>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
                              >
                                <div className="input-common mt-20">
                                  <TextField
                                    fullWidth
                                    id="fullWidth"
                                    rows={4}
                                    placeholder="Add value you want to collect*"
                                    type="search"
                                  />
                                </div>
                              </Grid2>
                            </Grid2>
                          </Grid2>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
                            sx={{ textAlign: "center" }}
                          >
                            <div className="shadow-btn Question-button mt-30">
                              <Button>Add</Button>
                            </div>
                            <div className="border-graient Question-button mt-10">
                              <Button
                                onClick={() => setIsInformationOpen(false)}
                              >
                                Close
                              </Button>
                            </div>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    ) : (
                      <Grid2
                        item
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        className="Add-Question-box"
                      >
                        <div className="">
                          <Button
                            startIcon={<AddIcon />}
                            onClick={() => setIsInformationOpen(true)}
                          >
                            Add Values
                          </Button>
                        </div>
                      </Grid2>
                    )}

                    <Grid2
                      item
                      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    >
                      <div className="display-1">
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                        >
                          Webhook :
                        </Typography>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Enter a POST HTTP endpoint to receive the data
                                collected during call. This can be any POST
                                webhook url from services like Zapier, goHigh
                                Level, your personal service endpoint etc.
                              </Typography>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                <b>Use Cases:</b> Can be used for meeting
                                bookings, Mail/Message(s) sending, etc.
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                    </Grid2>
                    <Grid2
                      item
                      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    >
                      <Grid2
                        container
                        spacing={2}
                        sx={{
                          alignItems: "center",
                          background: "#fff",
                          padding: "15px",
                          borderRadius: "12px",
                        }}
                        className="mt-10"
                      >
                        <Grid2
                          item
                          size={{ xs: 12, sm: 9, md: 9, lg: 9, xl: 9 }}
                        >
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h6"
                            sx={{ fontSize: "14px", fontWeight: "600" }}
                          >
                            https://www.fourchaintech.com/cryptocurrency-trading-bot-development
                          </Typography>
                        </Grid2>
                        <Grid2
                          item
                          size={{ xs: 12, sm: 3, md: 3, lg: 3, xl: 3 }}
                          sx={{ justifyContent: "end" }}
                        >
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "end" }}
                          >
                            {/* <EditIcon /> */}
                            <DeleteIcon />
                          </Stack>
                        </Grid2>
                      </Grid2>
                    </Grid2>

                    {isWebhookOpen ? (
                      <Grid2
                        item
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        className="Add-Question-box"
                      >
                        <Grid2
                          container
                          spacing={4}
                          sx={{ padding: "10px 30px 30px 30px" }}
                        >
                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
                          >
                            <Grid2 container spacing={1}>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                              >
                                <div className="display-1">
                                  <h3>Webhook Url</h3>
                                  <HtmlTooltip
                                    placement="right"
                                    title={
                                      <React.Fragment>
                                        <Typography
                                          color="inherit"
                                          sx={{
                                            fontSize: "12px",
                                            padding: "7px",
                                          }}
                                        >
                                          Enter a POST HTTP endpoint to receive
                                          the data collected during call. This
                                          can be any POST webhook url from
                                          services like Zapier, goHighLevel,
                                          your personal service endpoint etc.
                                        </Typography>
                                        <Typography
                                          color="inherit"
                                          sx={{
                                            fontSize: "12px",
                                            padding: "7px",
                                          }}
                                        >
                                          <b>Use Cases:</b> Can be used for
                                          meeting bookings, Mail/Message(s)
                                          sending, etc.
                                        </Typography>
                                      </React.Fragment>
                                    }
                                  >
                                    <InfoRoundedIcon />
                                  </HtmlTooltip>
                                </div>
                              </Grid2>
                              <Grid2
                                item
                                size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                              >
                                <div className="input-common mt-20">
                                  <TextField
                                    fullWidth
                                    id="fullWidth"
                                    rows={4}
                                    placeholder="Add value you want to collect*"
                                    type="search"
                                  />
                                </div>
                                <Grid2 container spacing={2}>
                                  <Grid2
                                    item
                                    size={{
                                      xs: 12,
                                      sm: 12,
                                      md: 8,
                                      lg: 8,
                                      xl: 8,
                                    }}
                                    sx={{
                                      textAlign: "start",
                                      marginTop: "30px",
                                    }}
                                  >
                                    <h5>Webhook Url Format:</h5>
                                    <div className="characters-heading">
                                      <img src={Tick} />
                                      <p> : Start with http:// or https://</p>
                                    </div>
                                    <div className="characters-heading">
                                      <img src={Tick} />
                                      <p>
                                        {" "}
                                        : Include a valid domain name (e.g.,
                                        example.com) and avoid spaces.
                                      </p>
                                    </div>
                                    <div className="characters-heading">
                                      <img src={Tick} />
                                      <p>
                                        {" "}
                                        : End with a valid top-level domain
                                        (e.g., .com, .org)
                                      </p>
                                    </div>
                                  </Grid2>
                                  <Grid2
                                    item
                                    size={{
                                      xs: 12,
                                      sm: 12,
                                      md: 4,
                                      lg: 4,
                                      xl: 4,
                                    }}
                                    sx={{ fontSize: "10px", marginTop: "30px" }}
                                  >
                                    <h5>Examples</h5>
                                    <p>http:// example.com</p>
                                    <p>https://example.com/path/to/resource</p>
                                    <p>https://www.example.com</p>
                                    <p>https://example.com/search?q=openai</p>
                                  </Grid2>
                                </Grid2>
                              </Grid2>
                            </Grid2>
                          </Grid2>
                          <Grid2
                            item
                            size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
                            sx={{ textAlign: "center" }}
                          >
                            <div className="shadow-btn Question-button mt-30">
                              <Button>Add</Button>
                            </div>
                            <div className="border-graient Question-button mt-10">
                              <Button onClick={() => setIsWebhookOpen(false)}>
                                Close
                              </Button>
                            </div>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    ) : (
                      <Grid2
                        item
                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        className="Add-Question-box"
                      >
                        <div className="">
                          <Button
                            startIcon={<AddIcon />}
                            onClick={() => setIsWebhookOpen(true)}
                          >
                            {" "}
                            Add Webhook
                          </Button>
                        </div>
                      </Grid2>
                    )}
                  </Grid2>
                </Box>
              </Collapse>
              <Box
                sx={{
                  padding: "16px 23px",
                  background: "#fff",
                  borderRadius: "12px",
                  border: "2px solid #8087D7",
                  marginTop: "30px",
                }}
              >
                <div className="display-2 ">
                  <div className="display-1">
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2"
                    >
                      Scheduling
                    </Typography>
                    <HtmlTooltip
                      placement="right"
                      title={
                        <React.Fragment>
                          <Typography
                            color="inherit"
                            sx={{ fontSize: "12px", padding: "7px" }}
                          >
                            <b>
                              Automate your campaign's operation by defining
                              specific working hours.
                            </b>
                          </Typography>
                          <Typography
                            color="inherit"
                            sx={{ fontSize: "12px", padding: "7px" }}
                          >
                            Specify <b>Start Time</b>, <b>End Time</b>, and{" "}
                            <b>Time Zone</b>: Configure Phone Numbers when your
                            campaign should run.
                          </Typography>
                          <Typography
                            color="inherit"
                            sx={{ fontSize: "12px", padding: "7px" }}
                          >
                            <b>How It Works</b>:
                          </Typography>
                          <ul>
                            <li>
                              {" "}
                              <Typography
                                color="inherit"
                                sx={{
                                  fontSize: "12px",
                                  padding: "7px",
                                  color: "#747474",
                                }}
                              >
                                <b>Automatic Operation</b>: The campaign starts
                                and stops according to your schedule.
                              </Typography>
                            </li>
                            <li>
                              {" "}
                              <Typography
                                color="inherit"
                                sx={{
                                  fontSize: "12px",
                                  padding: "7px",
                                  color: "#747474",
                                }}
                              >
                                <b>Daily Resumption</b>: Automatically resumes
                                each day within your set hours and continues
                                until completion..
                              </Typography>
                            </li>
                            <li>
                              {" "}
                              <Typography
                                color="inherit"
                                sx={{
                                  fontSize: "12px",
                                  padding: "7px",
                                  color: "#747474",
                                }}
                              >
                                <b>Manual Control</b>: Easily stop or resume the
                                campaign at any time.
                              </Typography>
                            </li>
                          </ul>
                        </React.Fragment>
                      }
                    >
                      <InfoRoundedIcon />
                    </HtmlTooltip>
                  </div>
                  <div className="">
                    <Switch
                      {...label}
                      color="secondary"
                      onClick={() => handleExpandClickMap1(!expandedMap1)}
                    />
                  </div>
                </div>
              </Box>
              <Collapse in={expandedMap1} timeout="auto" unmountOnExit>
                <Box
                  sx={{
                    padding: "20px 40px 80px 40px",
                    background: "rgba(47, 2, 78, 0.10)rgba(47, 2, 78, 0.10)",
                    borderRadius: "12px",
                    border: "2px solid #8087D7",
                    marginTop: "10px",
                  }}
                  className="box-pading"
                >
                  <Grid2 container spacing={2}>
                    <Grid2
                      item
                      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    >
                      <div className="display-1">
                        <h3>Scheduling</h3>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                <b>
                                  Automate your campaign's operation by defining
                                  specific working hours.
                                </b>
                              </Typography>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Specify <b>Start Time</b>, <b>End Time</b>, and{" "}
                                <b>Time Zone</b>: Configure Phone Numbers when
                                your campaign should run.
                              </Typography>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                <b>How It Works</b>:
                              </Typography>
                              <ul>
                                <li>
                                  {" "}
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                      color: "#747474",
                                    }}
                                  >
                                    <b>Automatic Operation</b>: The campaign
                                    starts and stops according to your schedule.
                                  </Typography>
                                </li>
                                <li>
                                  {" "}
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                      color: "#747474",
                                    }}
                                  >
                                    <b>Daily Resumption</b>: Automatically
                                    resumes each day within your set hours and
                                    continues until completion..
                                  </Typography>
                                </li>
                                <li>
                                  {" "}
                                  <Typography
                                    color="inherit"
                                    sx={{
                                      fontSize: "12px",
                                      padding: "7px",
                                      color: "#747474",
                                    }}
                                  >
                                    <b>Manual Control</b>: Easily stop or resume
                                    the campaign at any time.
                                  </Typography>
                                </li>
                              </ul>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                      <div className="display-1">
                        <label>Start Time</label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Set Start Time (24-hour format)
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <div className="input-common timePicker-button">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            // label={'Value timezone: "America/New_York"'}
                            value={value}
                            // onChange={setValue}
                            onChange={(newTime) =>
                              handleTimeChange("starttime", newTime)
                            }
                            name="starttime"
                            ampm={false}
                            renderInput={(params) => <TextField {...params} />}
                          />
                          {/* <Typography>
                              Stored value: {value == null ? 'null' : value.format()}
                            </Typography> */}
                        </LocalizationProvider>
                        <span
                        style={{
                          color: "#d32f2f",
                          fontSize: 13,
                          fontWeight: "bold",
                        }}
                      >
                        {errors.starttime}
                      </span>
                      </div>
                    </Grid2>
                    <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                      <div className="display-1">
                        <label>End Time </label>
                        <HtmlTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography
                                color="inherit"
                                sx={{ fontSize: "12px", padding: "7px" }}
                              >
                                Set End Time (24-hour format)
                              </Typography>
                            </React.Fragment>
                          }
                        >
                          <InfoRoundedIcon />
                        </HtmlTooltip>
                      </div>
                      <div className="input-common timePicker-button">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            // label={'Value timezone: "America/New_York"'}
                            // value={value}
                            // onChange={setValue}
                            // label={'Value timezone: "America/New_York"'}
                            value={endValue}
                            // onChange={setValue}
                            onChange={(newTime) =>
                              handleTimeChange("endtime", newTime)
                            }
                            name="endtime"
                            ampm={false}
                          />
                          {/* <Typography>
                              Stored value: {value == null ? 'null' : value.format()}
                            </Typography> */}
                        </LocalizationProvider>
                        <span
                        style={{
                          color: "#d32f2f",
                          fontSize: 13,
                          fontWeight: "bold",
                        }}
                      >
                        {errors.endtime}
                      </span>
                      </div>
                    </Grid2>
                    {/* <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }} >
                      <div className="input-common">
                      <div className="display-1">
                      <label>Time Zone  </label>
                          <HtmlTooltip placement="right"
                            title={
                              <React.Fragment>
                                <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>Select Time Zone.</Typography>
                              </React.Fragment>
                            }>
                            <InfoRoundedIcon />
                          </HtmlTooltip></div>
                        <Autocomplete
                          // sx={{ width: 300 }}
                          options={top100Films}
                          getOptionLabel={(option) => option.title}
                          renderInput={(params) => (
                            <TextField {...params}  margin="normal" />
                          )}
                          renderOption={(props, option, { inputValue }) => {
                            const { key, ...optionProps } = props;
                            const matches = match(option.title, inputValue, { insideWords: true });
                            const parts = parse(option.title, matches);

                            return (
                              <li key={key} {...optionProps}>
                                <div>
                                  {parts.map((part, index) => (
                                    <span
                                      key={index}
                                      style={{
                                        fontWeight: part.highlight ? 700 : 400,
                                      }}
                                    >
                                      {part.text}
                                    </span>
                                  ))}
                                </div>
                              </li>
                            );
                          }}
                        />
                      </div>
                    </Grid2> */}
                    <Grid2
                      item
                      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                    >
                      <div className="">
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                        >
                          Note :
                        </Typography>
                        <ul>
                          <li>
                            Your campaign will run according to the scheduled
                            hours each day and continue until it’s completed.
                          </li>
                          <li>
                            You can stop the campaign at any time, regardless of
                            the schedule.
                          </li>
                        </ul>
                      </div>
                    </Grid2>
                  </Grid2>
                </Box>
              </Collapse>

              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "center" }}
                className="mt-40 stck-btn"
              >
                <div className="border-graient mt-10">
                  <Button onClick={() => navigate("/campaign")}>Cancel</Button>
                </div>
                <div className="border-graient mt-10">
                  {/* <Button
                    // onClick={() => {
                    //   navigate("/campaign-overview");
                    // }}
                    onClick={handleSubmit}
                  >
                    Save
                  </Button> */}
                  {load ? (
                    <Button>Processing...</Button>
                  ) : (
                    <Button
                      // onClick={() => {
                      //   navigate("/contact-list-table");
                      // }}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  )}
                </div>
              </Stack>
            </Grid2>
          </Grid2>
        {/* </Box>
      </Box> */}
    </div>
  );
};

export default CreateCampaign;
// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "The Godfather", year: 1972 },
  { title: "The Godfather: Part II", year: 1974 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: "Pulp Fiction", year: 1994 },
  {
    title: "The Lord of the Rings: The Return of the King",
    year: 2003,
  },
  { title: "The Good, the Bad and the Ugly", year: 1966 },
  { title: "Fight Club", year: 1999 },
  {
    title: "The Lord of the Rings: The Fellowship of the Ring",
    year: 2001,
  },
  {
    title: "Star Wars: Episode V - The Empire Strikes Back",
    year: 1980,
  },
  { title: "Forrest Gump", year: 1994 },
  { title: "Inception", year: 2010 },
  {
    title: "The Lord of the Rings: The Two Towers",
    year: 2002,
  },
  { title: "One Flew Over the Cuckoo's Nest", year: 1975 },
  { title: "Goodfellas", year: 1990 },
  { title: "The Matrix", year: 1999 },
  { title: "Seven Samurai", year: 1954 },
  {
    title: "Star Wars: Episode IV - A New Hope",
    year: 1977,
  },
  { title: "City of God", year: 2002 },
  { title: "Se7en", year: 1995 },
  { title: "The Silence of the Lambs", year: 1991 },
  { title: "It's a Wonderful Life", year: 1946 },
  { title: "Life Is Beautiful", year: 1997 },
  { title: "The Usual Suspects", year: 1995 },
  { title: "Léon: The Professional", year: 1994 },
  { title: "Spirited Away", year: 2001 },
  { title: "Saving Private Ryan", year: 1998 },
  { title: "Once Upon a Time in the West", year: 1968 },
  { title: "American History X", year: 1998 },
  { title: "Interstellar", year: 2014 },
  { title: "Casablanca", year: 1942 },
  { title: "City Lights", year: 1931 },
  { title: "Psycho", year: 1960 },
  { title: "The Green Mile", year: 1999 },
  { title: "The Intouchables", year: 2011 },
  { title: "Modern Times", year: 1936 },
  { title: "Raiders of the Lost Ark", year: 1981 },
  { title: "Rear Window", year: 1954 },
  { title: "The Pianist", year: 2002 },
  { title: "The Departed", year: 2006 },
  { title: "Terminator 2: Judgment Day", year: 1991 },
  { title: "Back to the Future", year: 1985 },
  { title: "Whiplash", year: 2014 },
  { title: "Gladiator", year: 2000 },
  { title: "Memento", year: 2000 },
  { title: "The Prestige", year: 2006 },
  { title: "The Lion King", year: 1994 },
  { title: "Apocalypse Now", year: 1979 },
  { title: "Alien", year: 1979 },
  { title: "Sunset Boulevard", year: 1950 },
  {
    title:
      "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
    year: 1964,
  },
  { title: "The Great Dictator", year: 1940 },
  { title: "Cinema Paradiso", year: 1988 },
  { title: "The Lives of Others", year: 2006 },
  { title: "Grave of the Fireflies", year: 1988 },
  { title: "Paths of Glory", year: 1957 },
  { title: "Django Unchained", year: 2012 },
  { title: "The Shining", year: 1980 },
  { title: "WALL·E", year: 2008 },
  { title: "American Beauty", year: 1999 },
  { title: "The Dark Knight Rises", year: 2012 },
  { title: "Princess Mononoke", year: 1997 },
  { title: "Aliens", year: 1986 },
  { title: "Oldboy", year: 2003 },
  { title: "Once Upon a Time in America", year: 1984 },
  { title: "Witness for the Prosecution", year: 1957 },
  { title: "Das Boot", year: 1981 },
  { title: "Citizen Kane", year: 1941 },
  { title: "North by Northwest", year: 1959 },
  { title: "Vertigo", year: 1958 },
  {
    title: "Star Wars: Episode VI - Return of the Jedi",
    year: 1983,
  },
  { title: "Reservoir Dogs", year: 1992 },
  { title: "Braveheart", year: 1995 },
  { title: "M", year: 1931 },
  { title: "Requiem for a Dream", year: 2000 },
  { title: "Amélie", year: 2001 },
  { title: "A Clockwork Orange", year: 1971 },
  { title: "Like Stars on Earth", year: 2007 },
  { title: "Taxi Driver", year: 1976 },
  { title: "Lawrence of Arabia", year: 1962 },
  { title: "Double Indemnity", year: 1944 },
  {
    title: "Eternal Sunshine of the Spotless Mind",
    year: 2004,
  },
  { title: "Amadeus", year: 1984 },
  { title: "To Kill a Mockingbird", year: 1962 },
  { title: "Toy Story 3", year: 2010 },
  { title: "Logan", year: 2017 },
  { title: "Full Metal Jacket", year: 1987 },
  { title: "Dangal", year: 2016 },
  { title: "The Sting", year: 1973 },
  { title: "2001: A Space Odyssey", year: 1968 },
  { title: "Singin' in the Rain", year: 1952 },
  { title: "Toy Story", year: 1995 },
  { title: "Bicycle Thieves", year: 1948 },
  { title: "The Kid", year: 1921 },
  { title: "Inglourious Basterds", year: 2009 },
  { title: "Snatch", year: 2000 },
  { title: "3 Idiots", year: 2009 },
  { title: "Monty Python and the Holy Grail", year: 1975 },
];
